import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { isValid, isValidValueOrNull } from '../../validator';
import { UPDATE_PROJECT_CLIENTS_MUTATION, optimisticResponse } from './graphql';

const mapValuesOnSubmit = values => ({
  projectUri: values.projectUri,
  clients: isValid(values.client)
    ? [
        {
          client: {
            id: values.client.id,
            displayText: values.client.displayText
          },
          costAllocationPercentage: 100
        }
      ]
    : [],
  clientRepresentative: isValidValueOrNull(values.clientRepresentative)
});

export const onSubmit = ({ closeDialog, updateProject }) => (
  values,
  { setSubmitting }
) => {
  const payload = mapValuesOnSubmit(values);

  updateProject({
    variables: {
      projectInput: payload
    },
    optimisticResponse: optimisticResponse(payload)
  });

  closeDialog();
  setSubmitting(false);
};

export const useUpdateProjectClients = ({ closeDialog }) => {
  const [updateProject] = useMutation(UPDATE_PROJECT_CLIENTS_MUTATION);

  return useCallback(onSubmit({ closeDialog, updateProject }), [
    closeDialog,
    updateProject
  ]);
};
